/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_TitleInputs */

const en_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle Export`)
};

const fr_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation des sous-titres`)
};

const de_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel exportieren`)
};

const it_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione sottotitoli`)
};

const ru_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт субтитров`)
};

const es_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación de subtítulos`)
};

const zh_cn2_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出`)
};

const ja_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕エクスポート`)
};

const hi_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक निर्यात`)
};

const pt_pt2_subtitle_export_title = /** @type {(inputs: Subtitle_Export_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle Export" |
*
* @param {Subtitle_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_title = /** @type {((inputs?: Subtitle_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_title(inputs)
	if (locale === "de") return de_subtitle_export_title(inputs)
	if (locale === "it") return it_subtitle_export_title(inputs)
	if (locale === "ru") return ru_subtitle_export_title(inputs)
	if (locale === "es") return es_subtitle_export_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_title(inputs)
	if (locale === "ja") return ja_subtitle_export_title(inputs)
	if (locale === "hi") return hi_subtitle_export_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_title(inputs)
	return en_subtitle_export_title(inputs)
});